module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('h4', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: _vm.formRef,
    attrs: {
      "model": _vm.localData,
      "rules": _vm.rules,
      "inline": _vm.inlineForm,
      "label-position": _vm.labels,
      "label-width": _vm.labels !== 'top' ? _vm.maxLabel + 'px' : ''
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, _vm._l((this.form.fields), function(item) {
    return _c('span', {
      key: item.prop
    }, [_c('el-col', {
      attrs: {
        "span": _vm.spans
      }
    }, [(_vm.isNumberType(item)) ? _c('span', [(_vm.isDecimalType(item)) ? _c('float-input', {
      attrs: {
        "id": item.id,
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "min": item.min ? item.min : 0,
        "max": item.max ? item.max : Number.MAX_SAFE_INTEGER,
        "disabled": _vm.dis
      },
      on: {
        "change": _vm.updated
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    }) : _c('number-input', {
      attrs: {
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "disabled": _vm.dis
      },
      on: {
        "change": _vm.updated
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDateType(item)) ? _c('date-input', {
      attrs: {
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "format": item.format ? item.format : null,
        "disabled": _vm.dis
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isArrayType(item)) ? _c('select-input', {
      attrs: {
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "list": item.list,
        "disabled": _vm.dis
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTextType(item)) ? _c('text-input', {
      attrs: {
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "disabled": _vm.dis
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isHtmlType(item)) ? _c('html-input', {
      attrs: {
        "label": item.label,
        "required": item.required ? item.required : false,
        "prop": item.prop,
        "disabled": _vm.dis
      },
      model: {
        value: (_vm.localData[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.localData, item.prop, $$v)
        },
        expression: "localData[item.prop]"
      }
    }) : _vm._e()], 1)], 1)
  }), 0), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 23,
      "align": "right"
    }
  }, [(!_vm.dis) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "fa fa-check",
      "disabled": _vm.dis
    },
    on: {
      "click": _vm.localSave
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7461fe16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/AutoForm.vue
// module id = 1556
// module chunks = 0